import React from "react";

import Catalog from "../../Shared/CatalogList";
import { useSelector } from "react-redux";
import TileContainer from "../../Shared/TileContainer";
import { Container } from "@mui/material";
import Footer from "../../Footer";
import Slider from "../Slider/Slider";
import SliderBottom from "../SliderBottom/SliderBottom";
import ProductsCont from "../ProductCont/ProductCont";
import "./Home.css";
import Categorylist from "../CategoryList/CategoryList";
import ContainerSet2 from "../ContainerSet2/ContainerSet2";
import ContainerSet3 from "../../CardCont3/CardCont3";
import SliderBottom3 from "../SliderBottom copy/SliderBottom";
import HeroSection from "../../NewUiComponents/HeroSection/HeroSection";
import CardList from "../../CardList/CardList";

import DualPoster from "../ListPosters/ListPosters";
import styled from "styled-components";
import BoxCard from "../../BoxCard/BoxCard";
import HomePageSkeleton from "./LoadingShimmer";
import InfiniteProductList from "../../InfiniteScrollComp/InfiniteScrollComp";

const HomePageTest = () => {
  const homePageTiles = useSelector((state) => state?.HomePageTiles || []);
  const [loading,setLoading]= React.useState(true);
  React.useEffect(() => {
    if (homePageTiles.length > 0) {
      setLoading(false);
    }
  }, [homePageTiles]);
 


  console.log(homePageTiles);

  const HomeCont = styled.div`
  
  margin-top: 5rem;
  
  @media(max-width:851px){
  margin-top: 1rem;

    .homeset{
 margin-top: 0rem;
flex-direction:column;
}
  

  }

  @media(max-width:600px){
margin-top: 5rem;
}
  
  
  `
  const CategoryCont = styled.div`
  overflow-x: hidden;
  display: flex;
  flex-direction: row;
  max-width: 1441px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  width: 100%;
  padding: 0rem 1rem;



  @media(max-width:851px){
  padding: 0rem 0rem;

  margin-top: 0rem;
  margin-bottom: 0rem;
 

}
  
  
  `

  return (
    <>
     {loading ? (
       <HomePageSkeleton/>
     ) : (
           <>
                   <HomeCont className="home__cont" style={{ backgroundColor: "#f3f3f3" }}>
      <Categorylist />

     {homePageTiles[0]&& <HeroSection item={homePageTiles[0]} />}


      {homePageTiles[3]?  <CategoryCont className="homeset" >
        <ContainerSet3 /> <ContainerSet2 list = {homePageTiles[4]} />


      </CategoryCont>:<></>}




       {homePageTiles[4]&&<>     <CardList item={homePageTiles[1]} />
       <CardList item={homePageTiles[5]} /></>

       }
       {homePageTiles[6]&&<DualPoster list={homePageTiles[6].items} />}

    {/*    {homePageTiles[6]&&<DualPoster list={homePageTiles[7].items} />} */}

      {/*  {homePageTiles[6]&&<ProductsCont list = {homePageTiles[3].items}/>} */}
      {homePageTiles[2]&&<CardList item={homePageTiles[2]}  />}

       {/* <BoxCard/> */}

        {homePageTiles[4]&&<>     <CardList item={homePageTiles[4]} height='long' />
       </>

       }
{/* 
        <BoxCard/> */}

        {homePageTiles[3]&&<>     <CardList item={homePageTiles[3]} height='long' />
        
       </>

       }
        {homePageTiles[9]&&<>     <CardList item={homePageTiles[9]} />
        
       </>

       }
        {homePageTiles[10]&&<>     <CardList item={homePageTiles[10]} height='long' />
        
       </>

       }
        {homePageTiles[11]&&<>     <CardList item={homePageTiles[11]} />
        
       </>

       }
        {homePageTiles[12]&&<>     <CardList item={homePageTiles[12]} height='long' />
        
       </>

       }
        {homePageTiles[13]&&<>     <CardList item={homePageTiles[13]} height='long' />
        
       </>

       }
         {homePageTiles[14]&&<>     <CardList item={homePageTiles[14]} height='long' />

       </>

       }

         {homePageTiles[15]&&<>     <CardList item={homePageTiles[15]} height='long' />

       </>

       }
         {homePageTiles[16]&&<>     <CardList item={homePageTiles[16]}  />
        
       </>

       }
         {homePageTiles[17]&&<>     <CardList item={homePageTiles[17]} height='long' />

       </>

       }
         {homePageTiles[18]&&<>     <CardList item={homePageTiles[18]} />

       </>

       }
         {homePageTiles[19]&&<>     <CardList item={homePageTiles[19]} height='long' />

       </>

       }
         {homePageTiles[20]&&<>     <CardList item={homePageTiles[20]}  />

       </>

       }
         {homePageTiles[21]&&<>     <CardList item={homePageTiles[21]} height='long' />
        
       </>

       }
        {homePageTiles[22]&&<>     <CardList item={homePageTiles[22]} height='long' />

       </>

       }
        {homePageTiles[23]&&<>     <CardList item={homePageTiles[23]} height='long' />
        
       </>

       }
        {homePageTiles[24]&&<>     <CardList item={homePageTiles[24]} height='long' />

       </>

       }
        {homePageTiles[25]&&<>     <CardList item={homePageTiles[25]} height='long' />

       </>

       }
        {homePageTiles[26]&&<>     <CardList item={homePageTiles[26]} height='long' />

       </>

       }

  {/*    <InfiniteProductList/> */}
    </HomeCont>
      <Footer />
           </>
     )}
      </>
      
  );
};

export default HomePageTest;
